function hidingHeader(container, _a) {
    var _b = _a === void 0 ? {} : _a, _c = _b.contentSelector, contentSelector = _c === void 0 ? '*' : _c, _d = _b.heightPropertyName, heightPropertyName = _d === void 0 ? '--hidingHeader-height' : _d, _e = _b.boundsHeightPropertyName, boundsHeightPropertyName = _e === void 0 ? '--hidingHeader-bounds-height' : _e, _f = _b.animationOffsetPropertyName, animationOffsetPropertyName = _f === void 0 ? '--hidingHeader-animation-offset' : _f;
    var lastScrollTopPosition = 0;
    var lastContentHeight = 0;
    var paused = false;
    var lastBoundsHeight = 0;
    var content = container.querySelector(contentSelector);
    if (!(content instanceof HTMLElement)) {
        throw new Error("Content '" + contentSelector + "' not found in container.");
    }
    var parent = container.parentElement;
    if (parent === null) {
        throw new Error('Missing parent element.');
    }
    var getContentHeight = function () {
        return content.clientHeight;
    };
    var getParentHeight = function () {
        return parent.clientHeight;
    };
    var getGlobalTopOffset = function () {
        return container.offsetTop;
    };
    var getRelativeTopOffset = function () {
        var _a;
        return getGlobalTopOffset() - (((_a = container.parentElement) === null || _a === void 0 ? void 0 : _a.offsetTop) || 0);
    };
    var animateOffset = function (initialOffset) {
        if (initialOffset === 0) {
            return; // Nothing to animate
        }
        content.style.transition = 'none';
        container.style.setProperty(animationOffsetPropertyName, initialOffset + "px");
        content.offsetHeight; // Trigger transition
        content.style.transition = '';
        container.style.setProperty(animationOffsetPropertyName, '0px');
    };
    var updateBoundsHeight = function (boundsHeight) {
        if (boundsHeight !== lastBoundsHeight) {
            container.style.setProperty(boundsHeightPropertyName, boundsHeight + "px");
            lastBoundsHeight = boundsHeight;
        }
    };
    var capBoundsHeight = function (rawBoundsHeight) {
        return Math.min(getParentHeight() - getRelativeTopOffset(), Math.max(getContentHeight(), rawBoundsHeight));
    };
    var onScroll = function () {
        var globalTopOffset = getGlobalTopOffset();
        // Handle content height
        var contentHeight = getContentHeight();
        if (lastContentHeight !== contentHeight) {
            lastContentHeight = contentHeight;
            container.style.setProperty(heightPropertyName, lastContentHeight + "px");
        }
        // Handle bounds height
        var scrollTopPosition = window.scrollY;
        var isScrollingDown = scrollTopPosition > lastScrollTopPosition;
        if (!paused) {
            var boundsHeight = capBoundsHeight((function () {
                if (isScrollingDown) {
                    var newBoundsHeight = scrollTopPosition - globalTopOffset;
                    if (lastBoundsHeight < newBoundsHeight) {
                        return newBoundsHeight;
                    }
                    return lastBoundsHeight;
                }
                else {
                    var newBoundsHeight = scrollTopPosition - globalTopOffset + contentHeight;
                    if (lastBoundsHeight > newBoundsHeight) {
                        return newBoundsHeight;
                    }
                    return lastBoundsHeight;
                }
            })());
            updateBoundsHeight(boundsHeight);
        }
        lastScrollTopPosition = scrollTopPosition;
    };
    var onResize = onScroll;
    var initialize = function () {
        window.addEventListener('scroll', onScroll);
        window.addEventListener('resize', onResize);
        onScroll();
    };
    initialize();
    var run = function () {
        paused = false;
    };
    var pause = function () {
        paused = true;
    };
    var isPaused = function () {
        return paused;
    };
    var reveal = function () {
        var scrollTopPosition = window.scrollY;
        var contentHeight = getContentHeight();
        var globalTopOffset = getGlobalTopOffset();
        var boundsHeight = capBoundsHeight(scrollTopPosition - globalTopOffset + contentHeight);
        animateOffset(lastBoundsHeight - boundsHeight);
        updateBoundsHeight(boundsHeight);
    };
    var hide = function () {
        var scrollTopPosition = window.scrollY;
        var globalTopOffset = getGlobalTopOffset();
        var boundsHeight = capBoundsHeight(scrollTopPosition - globalTopOffset);
        animateOffset(lastBoundsHeight - boundsHeight);
        updateBoundsHeight(boundsHeight);
    };
    return {
        run: run,
        pause: pause,
        isPaused: isPaused,
        reveal: reveal,
        hide: hide,
    };
}

export { hidingHeader };
//# sourceMappingURL=index.es.js.map
